module.exports = __webpack_public_path__ + "media/music/synth_chords_6-6cff08b0.mp3";